import { Modal } from "antd";
import React from "react";
import styles from "./AllApprovedModal.module.scss";
import AcceptIcon from "../../../../assets/images/accept-icon.svg";
import { AllApprovedModalConstants } from "./constants";
import TNButton from "../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
} from "../../../../enums/ButtonAttributesEnums";
import { useHistory } from "react-router-dom";
import { appRoutes } from "../../../../constants/appRoutes";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";

interface AllApprovedModalProps {
  isOpen: boolean;
  handleClose: () => void;
  hasProcessingAccess?: boolean;
}

const AllApprovedModal = (props: AllApprovedModalProps) => {
  const navigate = useHistory();

  const { isOpen = false, handleClose, hasProcessingAccess = false } = props;
  const {
    HEADER,
    MESSAGE,
    RETURN_TO_TKT_UPLOAD,
    GO_TO_TKT_PROCESSING,
    BUTTON_CLASS,
  } = AllApprovedModalConstants;

  const handleReturnToTicketUpload = () => {
    handleClose();
    navigate.push(appRoutes.VIEW_TICKET_UPLOAD_LISTING);
  };

  const handleGoToTicketProcessing = () => {
    handleClose();
    navigate.push(appRoutes.VIEW_TICKET_PROCESSING_LISTING);
  };

  return (
    <Modal
      visible={isOpen}
      className={styles.allApprovedModal}
      footer={null}
      centered
      onCancel={handleReturnToTicketUpload}
      destroyOnClose
    >
      <div className={styles.allApprovedModalContent}>
        <img className={styles.allApprovedModalIcon} src={AcceptIcon} />
        <div className={styles.allApprovedModalText}>
          <h2>{HEADER}</h2>
          <h4>{MESSAGE}</h4>
        </div>
        <ConditionalRender visible={hasProcessingAccess}>
          <div className={styles.allApprovedModalButtons}>
            <TNButton
              size={ButtonSize.LARGE}
              shape={ButtonShape.DEFAULT}
              className={BUTTON_CLASS}
              text={RETURN_TO_TKT_UPLOAD}
              onClick={handleReturnToTicketUpload}
            />
            <TNButton
              size={ButtonSize.LARGE}
              shape={ButtonShape.DEFAULT}
              text={GO_TO_TKT_PROCESSING}
              className={BUTTON_CLASS}
              onClick={handleGoToTicketProcessing}
            />
          </div>
        </ConditionalRender>
      </div>
    </Modal>
  );
};

export default AllApprovedModal;
